var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-content"},[_c('my-action-items',{attrs:{"classroom":_vm.classroom}}),(!_vm.hideStudentActivity)?_c('student-activity',{attrs:{"classroom":_vm.classroom}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }